export default "__VITE_ASSET__695df8df__"